export default "__VITE_ASSET__4d997e7c__"